// saga redux helpers
import { takeLatest, put, call, all } from "redux-saga/effects";

import { SITE_WIDE_SEARCH } from "./actionType";

// actions
import { siteWideSearchSuccess, siteWideSearchFailure } from "./action";

// api

import { getSiteWideSearchAllDataApiCall } from "../../helpers/fakebackend_helper";

// Saga functions

function* getSiteWideSearchAllData({ payload }) {
  try {
    const response = yield call(getSiteWideSearchAllDataApiCall, payload);
    yield put(siteWideSearchSuccess(response));
  } catch (error) {
    yield put(siteWideSearchFailure(error));
  }
}

// Watcher functions

function* watchGetSiteWideSearchAllData() {
  yield takeLatest(SITE_WIDE_SEARCH, getSiteWideSearchAllData);
}

// Export watcher functions

export default function* SiteSearch() {
  yield all([watchGetSiteWideSearchAllData()]);
}
